Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.GradientType = module.exports.default = {
	LINEAR: "linear",
	RADIAL: "radial"
};